import React from 'react'
import styles from './CustomInput.module.css'



export function CustomInput({
  label,
  width,
  className,
  error,
  staticError,
  ...props
}) {

  const uniteClassNames = `${styles.container} ${className || ''}`

  return (
    <div className={uniteClassNames} style={{ width: width }}>
      <div>{label}</div>
      <input
        style={{ borderColor: error ? 'red' : '' }}
        {...props}
      />
      {error && <span style={{position: staticError ? 'static' : 'absolute'}}>{error}</span>}
    </div>
  )
}
